export const backgroundUser = [
    "https://images.wallpaperscraft.com/image/cat_eyes_blue_143433_2560x1080.jpg",
    "https://images.wallpaperscraft.com/image/cat_eyes_nose_133734_2560x1080.jpg",
    "https://images.wallpaperscraft.com/image/buildings_silhouettes_sunset_212784_2560x1080.jpg",
    "https://images.wallpaperscraft.com/image/spruce_cones_needles_212744_2560x1080.jpg",
    "https://images.wallpaperscraft.com/image/tree_horizon_minimalism_128903_2560x1080.jpg",
    "https://images.wallpaperscraft.com/image/tree_sunset_horizon_134872_2560x1080.jpg",
    "https://images.wallpaperscraft.com/image/tree_sunset_horizon_130905_2560x1080.jpg",
    "https://images.wallpaperscraft.com/image/tree_sunset_dark_149058_2560x1080.jpg",
    "https://images.wallpaperscraft.com/image/tree_sun_sunset_207524_2560x1080.jpg",
    "https://images.wallpaperscraft.com/image/road_marking_cloudy_124093_2560x1080.jpg",
    "https://images.wallpaperscraft.com/image/road_distance_marking_189982_2560x1080.jpg",
];